import { defineStore } from "pinia";
import { tiles_actions, tiles_getters, tiles_state } from "./tiles";

export const useTilesStore = defineStore("tiles", {
  state: () => tiles_state,
  actions: tiles_actions,
  getters: tiles_getters
});
